module.exports = __webpack_public_path__ + "img/bg_top.1768119790257.png";